import React, { Component } from "react";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { Container, Row, Col, Card, Spinner, InputGroup, FormControl } from "react-bootstrap";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logomarca from '../../assets/images/logo-hns-branco.png';
import Style from './Login.module.css'

class ResetarSenha extends Component {
    constructor(props) {
        super(props);
        this.handleResetar = this.handleResetar.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeConfPassword = this.onChangeConfPassword.bind(this);        

        this.state = {
            password: "",
            confPassword: "",
            showPassword: false,
            showConfPassword: false,       
            loading: false,
            loading_ambiente: true,
            programa_dados: [],
        };
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const programaId = searchParams.get("p");

        if (programaId) {
            this.carregaDadosPrograma(programaId);
        } else {
            this.setState({ loading_ambiente: false });
        }
    }

    carregaDadosPrograma = (programa_uuid) => {     
        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }

        api.get(`/programas/${programa_uuid}/`, config)
        .then(response => {
            this.setState({ 
                programa_dados: response.data,
                loading_ambiente: false,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar dados do programa atual:', error);            
        });
    };

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeConfPassword(e) {
        this.setState({
            confPassword: e.target.value
        });
    }

    toggleShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    toggleShowConfPassword = () => {
        this.setState(state => ({ showConfPassword: !state.showConfPassword }));
    };

    handleResetar(e) {
        const MySwal = withReactContent(Swal)
        const searchParams = new URLSearchParams(window.location.search);        
        const token = searchParams.get("token");  
        const clienteId = searchParams.get("c");
        const programaId = searchParams.get("p");      

        e.preventDefault();

        //verifica se senha e confirmação são iguais
        if(this.state.password != this.state.confPassword){
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>A confirmação de senha deve ser igual a sua senha</p>,
            })

            return false;
        }

        //verifica o token
        if(!token){
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Seu link de redefinição de senha é inválido, repita o processo novamente</p>,
            }).then((result) => {
                //redireciona
                if(programaId) {
                    this.props.router.navigate("/login/?p=" + programaId);  
                    window.location.href = `/login/?p=${programaId}`;
                } else {
                    this.props.router.navigate("/login/");  
                    window.location.reload();
                }
            });   

            return false;
        }

        this.setState({
            loading: true
        });

        let payload = {
            'password': this.state.password,
            'token': token,
        }        
        
        api({
            method: 'POST',
            url: '/password_reset/confirm/',
            data: payload
        })
        .then(response => {            
            this.setState({
                loading: false,
            })            

            MySwal.fire({
                title: 'Senha alterada',
                icon: 'success',
                html: 'Sua senha foi alterada com sucesso',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                if(programaId) {
                    this.props.router.navigate("/login/?p=" + programaId);  
                    window.location.href = `/login/?p=${programaId}`;
                } else {
                    this.props.router.navigate("/login/");  
                    window.location.reload();
                }
            });                      
        })
        .catch(error => {
            this.setState({ loading: false });
            // Mensagem da API
            const apiMsg = error.response?.data?.detail;
            const data = error.response?.data || {};
            let userMsg = '<p>Ocorreu um erro inesperado. Tente novamente mais tarde.</p>';

            if (Array.isArray(data.password)) {
                const itens = data.password
                .map(msg => `<li>${msg}</li>`)
                .join('');
                userMsg = `<ul class="text-start">${itens}</ul>`;
            } else if (apiMsg) {
                if (apiMsg.toLowerCase().includes('not valid') ||
                    apiMsg.toLowerCase().includes('expired')) {
                    userMsg = 'Seu link de redefinição de senha é inválido ou expirou. Por favor, solicite um novo link.';
                } else {
                    userMsg = apiMsg;
                }
            }

            MySwal.fire({
                icon: 'warning',
                title: 'Não foi possível redefinir a senha',
                html: userMsg,
                showCloseButton: true,
            });
        });
    }

    render() {      
        const {
            loading_ambiente,
            programa_dados,
            loading,
            password,
            confPassword,
            showPassword,
            showConfPassword
        } = this.state;
        
        return (
            <div className="login-page">
                <Container>
                    <Row>
                        <Col lg={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }} xs={12}>                           
                            {!loading_ambiente ? (
                                <div className="text-center mb-4">
                                    {programa_dados.imagem_branca ? (
                                        <div >
                                            <img src={programa_dados.imagem_branca} alt={programa_dados.nome} className={Style.loginLogomarca} />
                                        </div>
                                    ) : (
                                        <img src={logomarca} alt="Aditus" />
                                    )}
                                </div>
                            ) : (
                                <div className="text-center">
                                    <Spinner animation="border" className={Style.loginSpinner} />
                                </div>
                            )}
                            <Card className="mt-5">
                                <Card.Body>
                                    <h4>Informe uma nova senha e confirme abaixo para alterar sua senha</h4>
                                    <form onSubmit={this.handleResetar}>                                        
                                        <div className="form-group mb-3">
                                            <label>Nova Senha</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                required
                                                onChange={this.onChangePassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowPassword}
                                                >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label>Confirmação de Senha</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showConfPassword ? 'text' : 'password'}
                                                value={confPassword}
                                                required
                                                onChange={this.onChangeConfPassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowConfPassword}
                                                >
                                                {showConfPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <p>Requisitos da senha: </p>
                                        <ul>
                                            <li>Quantidade de caracteres maior que 8</li>
                                            <li>Uma letra minuscula</li>
                                            <li>Uma letra maiuscula</li>
                                            <li>Um número de 0 a 9</li>
                                            <li>Pelo menos um dos seguintes caracteres $@#$!%*?&</li>
                                        </ul>
                                        <div className="form-group mb-2 text-center">
                                            <button
                                                className="btn btn-first mt-3 btn-block"
                                                disabled={loading}
                                            >
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                )}
                                                <span>Alterar</span>
                                            </button>
                                        </div>                                       
                                    </form>                        
                                </Card.Body>
                            </Card>  
                            {this.state.programa_dados.imagem_branca && (
                                <div className="mt-5 text-center">
                                    <p className="text-white">Powered by <a href="https://aditushealth.com.br" target="_blank"><img src={logomarca} alt="Aditus Health" className={`ms-1 ${Style.loginPoweredBy}`} /></a></p>
                                </div>
                            )}                          
                        </Col>
                    </Row>
                </Container>
            </div>
        );
        
    }
}

export default withRouter(ResetarSenha);